export function measureStepAccordionActiveMaxHeight(
  list: HTMLElement,
  active: HTMLElement | null
): number | undefined {
  if (!active || list.clientHeight <= 0) {
    return undefined;
  }

  const styles = getComputedStyle(list);
  const gap = Number.parseFloat(styles.rowGap || styles.gap || '0') || 0;
  const children = Array.from(list.children) as HTMLElement[];
  let siblingHeight = 0;

  for (const child of children) {
    if (child !== active) {
      siblingHeight += child.getBoundingClientRect().height;
    }
  }

  const gapTotal = Math.max(0, children.length - 1) * gap;
  return Math.max(0, list.clientHeight - siblingHeight - gapTotal);
}
